import React from "react";
import UserStore from "../../store/user-store";

export const Welcomecard = () => {
    return (
        <div className="onboarding__main_content__logo">
            <img src="/images/logo.svg" alt="logo" />
            {UserStore.langCode === 'ru' ?
                <>
                    <h1>Добро пожаловать<br/> в {process.env.REACT_APP_NAME}</h1>

                </>
                :
                <>
                    <h1> Welcome to <br/> {process.env.REACT_APP_NAME}</h1>
                </>
            }

        </div>
    );
};
